const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:3000';

export async function cancelSubscription(token: string): Promise<{ accessUntil: string | null }> {
  const response = await fetch(`${API_BASE}/payments/cancel`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to cancel subscription');
  }

  return response.json();
}
